module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-wrap",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('button', {
    staticClass: "mt-button",
    class: "mt-button--" + _vm.type + (_vm.size == 'small' ? ' mt-button--small' : '') + (_vm.icon !== '' ? ' mt-button--icon' : '') + (_vm.isOnlyIcon ? ' isOnlyIcon' : ''),
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "mouseover": function($event) {
        _vm.hover = true
      },
      "mouseleave": function($event) {
        _vm.hover = false
      }
    }
  }, [(_vm.icon) ? [_c('mt-icon', {
    attrs: {
      "iconName": _vm.icon
    }
  })] : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      text: _vm.hasSlot
    }
  }, [_vm._t("default")], 2)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7301d58b","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/mtui/button/Button.vue
// module id = cy07
// module chunks = 0